export enum WidgetFontName {
  roboto = 'roboto',
  openSans = 'openSans',
  inter = 'inter',
  montserrat = 'montserrat',
  notoSans = 'notoSans',
  raleway = 'raleway',
  ubuntu = 'ubuntu',
  ptSans = 'ptSans'
}

export type FontInfo = {
  family: string;
  url: string;
};

export const FontMap: Record<WidgetFontName, FontInfo> = {
  [WidgetFontName.roboto]: {
    family: 'Roboto',
    url: 'https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap'
  },
  [WidgetFontName.openSans]: {
    family: 'Open Sans',
    url: 'https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500;600&display=swap'
  },
  [WidgetFontName.inter]: {
    family: 'Inter',
    url: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap'
  },
  [WidgetFontName.montserrat]: {
    family: 'Montserrat',
    url: 'https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600&display=swap'
  },
  [WidgetFontName.notoSans]: {
    family: 'Noto Sans',
    url: 'https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400;500;600&display=swap'
  },
  [WidgetFontName.raleway]: {
    family: 'Raleway',
    url: 'https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;600&display=swap'
  },
  [WidgetFontName.ubuntu]: {
    family: 'Ubuntu',
    url: 'https://fonts.googleapis.com/css2?family=Ubuntu:wght@400;500;700&display=swap'
  },
  [WidgetFontName.ptSans]: {
    family: 'PT Sans',
    url: 'https://fonts.googleapis.com/css2?family=PT+Sans:wght@400;700&display=swap'
  }
};

export const WidgetFontsOrder: WidgetFontName[] = [
  WidgetFontName.roboto,
  WidgetFontName.openSans,
  WidgetFontName.inter,
  WidgetFontName.montserrat,
  WidgetFontName.notoSans,
  WidgetFontName.raleway,
  WidgetFontName.ubuntu,
  WidgetFontName.ptSans
];

export const DEFAULT_FONT_NAME = WidgetFontName.roboto;
